import { useMutation } from "@tanstack/react-query";
import { callApi } from "../../utils/ApiCallPostOnly";

export const useCancelReturn = () => {
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "receivedreturnordercard",
        command: "delete",
        data: JSON.stringify(data),
      }),
  });
};
